import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bd7ff8de&scoped=true&"
import script from "./index.vue?vue&type=script&setup=true&lang=ts&"
export * from "./index.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=bd7ff8de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7ff8de",
  null
  
)

export default component.exports